import {Col, Row, Button} from 'antd';
import {BsFillArrowLeftCircleFill} from 'react-icons/bs';
import {FaRegListAlt} from 'react-icons/fa';
import {useNavigate} from 'react-router-dom';
import {useIntl} from 'react-intl';
import IntlMessages from '../../../../../../domain/utility/IntlMessages';
import {useLocaleContext} from 'src/domain/utility/AppContextProvider/LocaleContextProvide';

interface IEditProductAttributeHeaderProps {
  productAttributesDetails?: any;
}
const EditProductAttributeHeader = (
  props: IEditProductAttributeHeaderProps,
) => {
  const {productAttributesDetails} = props;

  const {messages} = useIntl();

  const navigate = useNavigate();

  const {locale}: any = useLocaleContext();

  return (
    <Row>
      <Col lg={24}>
        <div className='text-title'>
          <span className='icon-title'>
            <FaRegListAlt />
          </span>

          {/* add locales */}
          {`${messages[
            'productAttributes.editproductAttributesDetails'
          ].toString()} - ${
            productAttributesDetails?.Locales?.find(
              (item: any) => item.LanguageId === locale.code,
            )?.LocaleValue ?? productAttributesDetails?.Name
          }`}
          <small className='back-to-list'>
            <BsFillArrowLeftCircleFill className='back-to-icon' />
            <a
              onClick={() => {
                navigate('/catalog/catalog.attributes/product-attributes');
              }}>
              <IntlMessages id='productAttributes.backToproductAttributesList' />
            </a>
          </small>
        </div>
      </Col>
    </Row>
  );
};

export default EditProductAttributeHeader;
